import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function PrivacyPolicy({ darkMode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section id="privacy-policy" className={`py-10 transition-colors duration-300
      ${darkMode ? 'bg-[#080D1A]' : 'bg-[#F0EDE6]'}`}>
      <div className="container mx-auto px-4 lg:px-16">
        <div className={`max-w-3xl mx-auto rounded-2xl border overflow-hidden
          ${darkMode ? 'bg-[#0D1525] border-[#C9A84C]/10' : 'bg-white border-[#C9A84C]/20'}`}>

          <button
            className={`w-full flex items-center justify-between p-6 text-left transition-colors
              ${darkMode ? 'hover:bg-[#C9A84C]/5' : 'hover:bg-[#C9A84C]/5'}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className={`text-sm font-semibold tracking-wide ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>
              Privacy Policy
            </span>
            <ChevronDown
              size={18}
              className={`text-[#C9A84C] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
            />
          </button>

          {isOpen && (
            <div className={`px-6 pb-6 border-t space-y-5 text-sm leading-relaxed
              ${darkMode ? 'border-[#C9A84C]/10 text-gray-400' : 'border-[#C9A84C]/15 text-gray-600'}`}>
              <div className="pt-5">
                <p>We value your privacy and are committed to protecting your personal information. By filling out this form, you consent to us collecting and processing the information you provide for the purpose of offering you personalized policy planning advice.</p>
              </div>

              <div>
                <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>What Information We Collect</h3>
                <ul className="space-y-1 list-none">
                  {['Personal details such as your name, email, and phone number.', 'Any other information relevant to your policy planning needs.'].map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0"></span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>How We Use Your Information</h3>
                <ul className="space-y-1 list-none">
                  {['To provide you with a personalized consultation.', 'To send you updates, offers, and other information related to best policies for you.'].map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0"></span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>How We Protect Your Information</h3>
                <p>We implement security measures to protect your personal information from unauthorized access, use, or disclosure.</p>
              </div>

              <div>
                <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>Your Rights</h3>
                <ul className="space-y-1 list-none">
                  {['You may opt out of receiving communications from us at any time.', 'You have the right to access, modify, or delete your personal information.'].map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0"></span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <p>By submitting your details, you agree to this Privacy Policy. For any questions or concerns, feel free to contact us.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}